(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ccpa_form"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ccpa-form')) {
    class CCPAForm extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.form = this.querySelector('button[type="submit"]');

        this.form.addEventListener('click', this.onFormSubmit.bind(this));
      }

      onFormSubmit(evt) {
        const hasErrors = this.validateCheckboxes();

        if(hasErrors) {
          evt.preventDefault();
          evt.stopPropagation();
          this.classList.add('has-error');
        } else {
          this.classList.remove('has-error');
        }
      }

      validateCheckboxes() {
        const checkedInput = this.querySelectorAll('input[type="checkbox"]:checked');
        return checkedInput.length == 0;
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('ccpa-form', CCPAForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-bis-form"]) return;
  try {
    
  if(!customElements.get('bis-modal')) {
    class bisModal extends HTMLElement {
      constructor() {
        super();
        this.dialog = this.querySelector('dialog');
        this.bisForm = this.querySelector('form');
        this.productTitle = this.querySelector('[data-product-title]');
        this.variantName = this.querySelector('[data-product-variant]');
        this.variantId = this.querySelector('[data-bis-variant-id]');
        this.productId = this.querySelector('[data-bis-product-id]');
        this.bisTypeSelectors = this.querySelectorAll('input[type="radio"]');
        this.closeButton = this.querySelector('[data-close-button]');
        this.newsletterCheckbox = this.querySelector('[data-consent-checkbox]');
        this.smsDisclaimer = this.querySelector('[data-sms-disclaimer]');
        this.zipCodeField = this.querySelector('[data-zip-code-field]');
        this.bisButton = document.querySelector('[is="bis-button"]');
        this.variantStatus = document.querySelector('[data-variant-status]');
        this.productIdEl = document.querySelector('[data-block-type="buy-buttons"] [name="id"]')
        this.buyButton = document.querySelector('buy-buttons [type="submit"]');
      }

      connectedCallback() {
        document.addEventListener('bisForm:open', this.openModal.bind(this));
        if(!this.variantStatus) {
          return;
        }
        this.variantList = JSON.parse(this.variantStatus?.innerHTML)

        this.bisTypeSelectors.forEach((radio) => {
          radio.addEventListener('change', (evt) => {
            let emailAction = 'remove';
            let smsAction = 'add';
            if(evt.target.value == 'sms') {
              emailAction = 'add';
              smsAction = 'remove';
            }
            this.querySelector('input[type="email"]').classList[emailAction]('hidden');
            this.querySelector('input[type="tel"]').closest('.iti').classList[smsAction]('hidden');
            this.smsDisclaimer.classList[smsAction]('hidden');
          })
        })

        this.bisForm?.addEventListener('submit', this.submitModal.bind(this));
        this.closeButton.addEventListener('click', this.closeModal.bind(this));
        this.bisButton.addEventListener('click', this.onBisButtonClick.bind(this));
        document.addEventListener('variant:change', this.onVariantChange.bind(this));
        this.klaviyoPublicKey = this.getKlaviyoPublicKey();
        this.reviewBisButtonStatus()
      }

      getKlaviyoPublicKey = () => {
        const script = Array.from(document.scripts).find(s =>
          s.src.includes("static.klaviyo.com/onsite/js/")
        );
        if (!script) return null;

        const match = script.src.match(/onsite\/js\/([^/]+)\/klaviyo\.js/);
        return match ? match[1] : null;
      }

      openModal(evt) {
        const info = evt.detail;

        this.productTitle.innerText = info.productTitle;
        this.variantName.innerText = info.variantTitle;
        this.productId.value = info.productId;
        this.variantId.value = info.variantId;

        this.dialog.showModal();
      }

      closeModal() {
        this.dialog.close();
      }

      submitModal(evt) {
        evt.preventDefault();
        evt.stopPropagation();

        const formValid = this.validateFormFields();

        if(!formValid) {
          this.updateFormMessage({
            message: "All fields are required",
            success: false,
          })

          return;
        }

        const zipCode = this.zipCodeField.value;

        const payload = {
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: [],
              profile: {
                data: {
                  type: "profile",
                  attributes: {},
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${this.variantId.value}`,
                },
              },
            },
          },
        };

        const updatePayload = {
          data: {
            type: "profile",
            attributes: {
              properties: {},
            }
          }
        }

        const email = this.bisForm.querySelector('input[type="email"').value;

        payload.data.attributes.channels.push("EMAIL");
        payload.data.attributes.profile.data.attributes.email = email;
        updatePayload.data.attributes.email = email;

        if(zipCode) {
          updatePayload.data.attributes.properties["zip-code"] = zipCode;
        }

        fetch(
          `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${this.klaviyoPublicKey}`,
          {
            headers: {
              accept: "application/vnd.api+json",
              "content-type": "application/vnd.api+json",
              revision: "2025-04-15",
            },
            method: "post",
            body: JSON.stringify(payload),
          }
        ).then(async (data) => {
          if (data.status == 202) {
            await fetch(`https://a.klaviyo.com/client/profiles?company_id=${this.klaviyoPublicKey}`, {
                headers: {
                  accept: "application/vnd.api+json",
                  "content-type": "application/vnd.api+json",
                  revision: "2025-07-15"
                },
                method: "post",
                body: JSON.stringify(updatePayload)
              })

              this.updateFormMessage({
                message: "We'll Notify You When It's Back In Stock",
                success: true,
              })
          } else {
            const response = await data.json();
            const errorsMsg = await response.errors.map((error) => {
              return error.detail;
            });

            this.updateFormMessage({
              message: errorsMsg.join('<br/>'),
              suicces: false
            })
          }
        });
      }

      updateFormMessage({
        message,
        success
      }) {
        const confirmMessage = this.querySelector("[data-confirm-message]");
        const successIcon = this.querySelector(".bis-modal-form__confirm-message svg");

        if(!success) {
          successIcon.style.display = "none";
          confirmMessage.style.color = "rgb(var(--error-text))"
        }

        confirmMessage.innerHTML = message;
        confirmMessage.parentElement.removeAttribute('hidden');

        setTimeout(() => {
          confirmMessage.parentElement.setAttribute('hidden', true);
          confirmMessage.removeAttribute('style');
          successIcon.removeAttribute('style');
        }, 5000);
      }

      reviewBisButtonStatus() {
        if(!this.bisButton) {
          return;
        }

        const selectedId = this.productIdEl.value;
        const currentIdObject = this.variantList[selectedId];

        if(currentIdObject.available) {
          this.hideBisButton();
        } else {
          this.showBisButton();
        }
      }

      showBisButton() {
        this.buyButton.style.display = "none";
        this.buyButton.setAttribute('disabled', true);
        this.bisButton.removeAttribute('hidden');
      }

      hideBisButton() {
        this.buyButton.style.display = "block";
        this.buyButton.removeAttribute('disabled');
        this.bisButton.setAttribute('hidden', true);
      }

      onVariantChange(evt) {
        const variantDetail = evt.detail;

        if(variantDetail.variant.available) {
          this.hideBisButton();
        } else {
          this.showBisButton();
        }
      }

      validateFormFields() {
        const fields = Array.from(this.querySelectorAll('input[required]'));
        let validForm = true;

        fields.forEach((field) => {
          const isValid = field.checkValidity();

          if(!isValid) {
            field.classList.add('has-error');
            field.addEventListener('keyup', (evt) => {
              evt.target.classList.remove('has-error')
            }, {once: true})

            if(validForm) {
              field.focus();
            }

            validForm = false;
          }
        })

        return validForm;
      }

      onBisButtonClick() {
        const selectedId = this.productIdEl.value;
        const currentIdObject = this.variantList[selectedId];

        document.dispatchEvent(new CustomEvent('bisForm:open', {
          detail: {
            variantId: selectedId,
            variantTitle: currentIdObject.title,
            productTitle: currentIdObject.productTitle,
          }
        }))
      }
    }

    customElements.define('bis-modal', bisModal);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-rebuy"]) return;
  try {
    
(function () {
  'use strict';

  // ─── MODULE-LEVEL CONSTANTS ──────────────────────────────────────────────

  var EAGER_COUNT   = 8;
  var API_BASE      = 'https://rebuyengine.com/api/v1/smart-collections';

  var SHOPIFY_SORT_MAP = {
    'manual':             { field: 'relevance',   order: 'desc' },
    'best-selling':       { field: 'best_selling', order: 'desc' },
    'title-ascending':    { field: 'title',        order: 'asc'  },
    'title-descending':   { field: 'title',        order: 'desc' },
    'price-ascending':    { field: 'price',        order: 'asc'  },
    'price-descending':   { field: 'price',        order: 'desc' },
    'created-ascending':  { field: 'created_at',   order: 'asc'  },
    'created-descending': { field: 'created_at',   order: 'desc' }
  };

  var DEFAULT_SORT = { field: 'relevance', order: 'desc' };

  var CUSTOM_GRID_INJECTED_CLASS = 'product-custom-card--injected';

  function _removeInjectedCustomGridItems(productListEl) {
    productListEl.querySelectorAll('.' + CUSTOM_GRID_INJECTED_CLASS).forEach(function (el) {
      el.remove();
    });
  }

  function _cloneCustomGridNodeFromTemplate(template) {
    var fragment = template.content.cloneNode(true);
    var node = fragment.firstElementChild;
    if (!node) return null;
    node.classList.add(CUSTOM_GRID_INJECTED_CLASS);
    return node;
  }

  // ─── CUSTOM ELEMENT ──────────────────────────────────────────────────────

  class RebuyCollection extends HTMLElement {
    constructor() {
      super();
      this._config        = null;
      this._isInitialLoad = true;
      this._state = {
        products: [],
        aggregates: [],
        pageInfo: {},
        filters: {
          tags: [], categories: [], vendors: [], options: [], metafields: [],
          available: null, price: {}
        },
        sortBy: { field: 'relevance', order: 'desc' },
        currentPage: 1,
        loading: false,
        collectionFilterSettings: null
      };

      this._settingsFetched = false;
      this._productListEl   = null;
    }

    connectedCallback() {
      this.abortController = new AbortController();

      var configEl = document.getElementById('rebuy-collection-config');
      if (!configEl) return;

      try {
        this._config = JSON.parse(configEl.textContent);
      } catch (e) {
        console.error('Rebuy: failed to parse config', e);
        return;
      }

      if (!this._config.rebuyApiKey || !this._config.collectionHandle) {
        console.warn('Rebuy: missing API key or collection handle');
        return;
      }

      window.__productCardConfig = this._config;
      this._productListEl = document.querySelector(`#product-list-${this._config.sectionId}`);
      this._state.currentPage = this._getPageFromUrl();
      this._state.sortBy = this._getSortFromUrl();

      this._setupSortIntercept();
      this._setupEventDelegation();
      this._addCustomEventListeners();
      this._readFiltersFromUrl();
      this._fetchProducts();
    }

    disconnectedCallback() {
      this.abortController.abort();
      if (this._onFacetUpdate) {
        document.removeEventListener('facet:update', this._onFacetUpdate, true);
      }
    }

    _getPageFromUrl() {
      let v = new URLSearchParams(window.location.search).get('page')
      return v || 1;
    }

    _getSortFromUrl() {
      var v = new URLSearchParams(window.location.search).get('sort_by');
      return SHOPIFY_SORT_MAP[v] || DEFAULT_SORT;
    }

    _readFiltersFromUrl() {
      var params  = new URLSearchParams(window.location.search);
      var filters = { tags: [], categories: [], vendors: [], options: [], metafields: [], available: null, price: {} };

      filters.available = params.get('f.availability') === 'true' ? true : null;

      var priceGte = params.get('f.price.gte');
      var priceLte = params.get('f.price.lte');
      if (priceGte !== null) filters.price.min = parseInt(priceGte, 10);
      if (priceLte !== null) filters.price.max = parseInt(priceLte, 10);

      filters.tags = params.getAll('f.tags');
      filters.categories = params.getAll('f.product_type');
      filters.options = params.getAll('f.options');
      filters.metafields = params.getAll('f.metafield');
      filters.vendors = params.getAll('f.vendor');

      this._state.filters = filters;
    }

    _syncFiltersToUrl() {
      var Url    = new URL(window.location.href);
      var params = Url.searchParams;

      var f = this._state.filters;


      params.delete('f.tags');
      f.tags.forEach(function (v)       { params.append('f.tags', v); });

      params.delete('f.product_type');
      f.categories.forEach(function (v) { params.append('f.product_type', v); });

      params.delete('f.vendor');
      f.vendors.forEach(function (v)    { params.append('f.vendor', v); });

      params.delete('f.options');
      f.options.forEach(function (v)    { params.append('f.options', v); });

      params.delete('f.metafield');
      f.metafields.forEach(function (v) { params.append('f.metafield', v); });

      if (f.available === true)  params.delete('f.availability').set('f.availability', 'true');
      if (f.price.min != null)   params.delete('f.price.max').set('f.price.max', String(f.price.min));
      if (f.price.max != null)   params.delete('f.price.min').set('f.price.min', String(f.price.max));

      if (this._state.currentPage > 1) params.set('page', this._state.currentPage);
      history.replaceState({}, '', Url.toString());
    }

    // ─── CUSTOM EVENT LISTENERS ─────────────────────────────────────────────
    // The window.__rebuy* globals dispatch CustomEvents; the element handles
    // them here so all state mutations stay encapsulated in the component.

    _addCustomEventListeners() {
      this._onToggleFilter = (e) => this._toggleFilter(e.detail.key, e.detail.value);

      this._onResetFilters = () => this._resetFilters();

      this._onGoToPage = (e) => this._goToPage(e.detail.page);

      document.addEventListener('rebuy:filter:toggle',              this._onToggleFilter, { signal: this.abortController.signal });
      document.addEventListener('rebuy:filter:reset',               this._onResetFilters, { signal: this.abortController.signal });
      document.addEventListener('rebuy:goto-page',                  this._onGoToPage, { signal: this.abortController.signal });
    }

    // ─── EVENT DELEGATION ───────────────────────────────────────────────────

    _setupEventDelegation() {
      var paginationEl = document.getElementById('rebuy-pagination');
      if (paginationEl) {
        paginationEl.addEventListener('click', (e) => {
          var btn = e.target.closest('[data-rebuy-page]');
          if (!btn) return;
          this._goToPage(parseInt(btn.getAttribute('data-rebuy-page'), 10));
        });
      }

      if (this._productListEl && this._productListEl.parentNode) {
        this._productListEl.parentNode.addEventListener('click', (e) => {
          if (e.target.closest('[data-rebuy-action="reset-filters"]')) this._resetFilters();
        });
      }

    }

    // ─── API ────────────────────────────────────────────────────────────────

    _buildRequestBody() {
      var body = {
        sortBy: this._state.sortBy,
        pageSize: this._config.productsPerPage || 48,
        currentPage: this._state.currentPage,
        filters: {},
        aggregate: {
          fields: ["availability", "tags", "options", "categories", "vendors", "metafields", "price"]
        }
      };
      if (this._state.filters.tags.length)        body.filters.tags        = this._state.filters.tags;
      if (this._state.filters.categories.length)  body.filters.categories  = this._state.filters.categories;
      if (this._state.filters.vendors.length)     body.filters.vendors     = this._state.filters.vendors;
      if (this._state.filters.options.length)     body.filters.options     = this._state.filters.options;
      if (this._state.filters.metafields.length)  body.filters.metafields  = this._state.filters.metafields;
      if (this._state.filters.available === true) body.filters.available   = true;
      if (this._state.filters.price.min != null || this._state.filters.price.max != null) {
        body.filters.price = {};
        if (this._state.filters.price.min != null) body.filters.price.min = this._state.filters.price.min;
        if (this._state.filters.price.max != null) body.filters.price.max = this._state.filters.price.max;
      }
      return body;
    }

    _fetchCollectionSettings() {
      var url = `${API_BASE}/${this._config.collectionHandle}/setting?key=${encodeURIComponent(this._config.rebuyApiKey)}`;
      return fetch(url, { headers: { 'Rebuy-Api-Key': this._config.rebuyApiKey } })
        .then(function (res) { return res.json(); }).then(value => { this._state.collectionFilterSettings = value; return value;})
        .catch(function (err) {
          console.warn('Rebuy: could not load filter settings', err);
        });
    }

    _fetchProducts() {
      if (this._state.loading) return;
      this._syncFiltersToUrl();
      this._state.loading = true;
      this._showLoadingState();

      const url = `${API_BASE}/${this._config.collectionHandle}/products?key=${encodeURIComponent(this._config.rebuyApiKey)}`;
      const productsPromise = fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(this._buildRequestBody())
      }).then(function (res) { return res.json(); });

      const settingsPromise = this._settingsFetched
        ? Promise.resolve({...this._state.collectionFilterSettings})
        : this._fetchCollectionSettings().finally(() => { this._settingsFetched = true; });

      Promise.all([productsPromise, settingsPromise])
        .then((results) => {
          let data = results[0];
          let settings = results[1];

          this._state.loading = false;
          if (data.successful && data.data) {
            this._state.products   = data.data.products   || [];
            this._state.aggregates = this._normalizeAggregates(data.data.aggregates || [], settings.data.filters);
            this._state.pageInfo   = data.data.pageInfo   || {};
            this._render();
          } else {
            this._renderError();
          }
        })
        .catch((err) => {
          this._state.loading = false;
          console.error('Rebuy: fetch error', err);
          this._renderError();
        });
    }

    // ─── LOADING STATE ───────────────────────────────────────────

    _showLoadingState() {
      if (this._productListEl && !this._isInitialLoad) {
        this._productListEl.style.opacity = '0.5';
        this._productListEl.style.pointerEvents = 'none';
      }
    }

    // ─── RENDER ORCHESTRATION ───────────────────────────────────────────────

    _render() {
      this._renderProducts();
      document.dispatchEvent(new CustomEvent('rebuy:renderFilters', {
        detail: {
          aggregates: this._state.aggregates,
          filterSettings: this._state.collectionFilterSettings,
          filters: this._state.filters,
          config: this._config
        }
      }))

      document.dispatchEvent(new CustomEvent('rebuy:renderActiveFacets', {
        detail: {
          filters: this._state.filters,
          config: this._config,
        }
      }))

      this._renderPagination();
      this._updateResultCount();
      this._updateActiveFilterCount();
      this._injectCustomGridItem();
      this._isInitialLoad = false;
    }

    // ─── PRODUCT RENDERING ──────────────────────────────────────────────────

    _renderProducts() {
      if (!this._productListEl) return;

      this._productListEl.style.opacity    = '';
      this._productListEl.style.pointerEvents = '';
      this._productListEl.innerHTML = '';

      if (this._state.products.length === 0) {
        var emptyEl = document.createElement('div');
        emptyEl.className = 'empty-state';
        emptyEl.innerHTML = `
          <div class="prose">
            <p>${this._config.noResultsText}</p>
            <button type="button" class="button" data-rebuy-action="reset-filters">${this._config.clearFiltersText}</button>
          </div>
        `;
        this._productListEl.parentNode.insertBefore(emptyEl, this._productListEl);
        return;
      }

      var existingEmpty = this._productListEl.parentNode.querySelector('.empty-state');
      if (existingEmpty) existingEmpty.remove();

      var fragment = document.createDocumentFragment();
      var products = this._state.products;

      for (var i = 0; i < products.length; i++) {
        var card = document.createElement('rebuy-product-card');
        card.className = 'product-card';
        card.dataset.product = JSON.stringify(products[i]);
        card.dataset.eager = String(i < EAGER_COUNT);
        fragment.appendChild(card);
      }

      this._productListEl.appendChild(fragment);

      if (this._productListEl.reveal) this._productListEl.reveal();
      this._reinitYotpo();
    }

    // ─── AGGREGATES NORMALIZATION ───────────────────────────────────────────

    _normalizeAggregates(aggregates, settings) {
      const out = [];

      if(!aggregates?.length) return out;

      const sortedSettings = settings.filter((loopSetting) => loopSetting.enabled == true).sort((a, b) => {
        return a.index - b.index
      })

      sortedSettings.forEach(setting => {
        const filterLabel = setting.label != "" ? setting.label : setting.name;
        const filterName = setting.name;

        let filterReference = setting.type;
        let filterKey = null;
        let aggregateKey; /*To remove*/

        if(setting.type == 'availability') {
          out.push({
            label: filterLabel,
            name: filterName,
            type: "available"
          })
          return;
        }
        if(setting.type == 'price') {
          let filterValues = aggregates.find(aggregate => aggregate.hasOwnProperty(filterReference))
          if(!filterValues) return;

          out.push({
            label: filterLabel,
            name: filterName,
            type: "price",
            values: {
              min: filterValues[filterReference][0].min,
              max: filterValues[filterReference][0].max,
            }
          })
          return;
        }

        if(setting.type == 'product-type') {
          let filterValues = aggregates.find(aggregate => aggregate.hasOwnProperty('categories'))
          if(!filterValues) return;

          out.push({
            name: filterName,
            label: filterLabel,
            type: "categories",
            values: Object.entries(filterValues.categories).map(([key, value])=> {
              return {
                label: value.categories,
                numProducts: value.numProducts,
                value: value.categories
              }
            })
          })

          return;
        }

        if(setting.type == 'product-tags') {
          let filterValues = aggregates.find(aggregate => aggregate.hasOwnProperty('tags'))
          if(!filterValues) return;

          out.push({
            name: filterName,
            label: filterLabel,
            type: "tags",
            values: Object.entries(filterValues.tags).map(([key, value]) => {
              return {
                label: value.tags,
                numProducts: value.numProducts,
                value: value.tags,
              }
            })
          })

          return;
        }

        if(setting.type == 'vendor') {
          let filterValues = aggregates.find(aggregate => aggregate.hasOwnProperty('vendorAsTag'))
          if(!filterValues) return;

          out.push({
            name: filterName,
            label: filterLabel,
            type: "vendors",
            values: Object.entries(filterValues.vendorAsTag).map(([key,value]) => {
              return {
                label: value.vendorAsTag,
                numProducts: value.numProducts,
                value: value.vendorAsTag
              }
            })
          })

          return;
        }

        if(setting.type == 'product-options') {
          let filterValues = aggregates.find(aggregate => aggregate.hasOwnProperty("options"))

          filterValues = filterValues.options.find(arrayObject => {
            return arrayObject.option == setting.name;
          });
          if(!filterValues) return;

          out.push({
            label: filterLabel,
            name: filterName,
            type: 'options',
            values: Object.entries(filterValues.values).map(([key, value]) => {
              return {
                label: key,
                numProducts: value.numProducts,
                value: `${filterName} # ${key}`
              }
            })
          })

          return;
        }

        if(setting.type == 'variant-metafield' || setting.type == 'product-metafield') {
          let filterValues = aggregates.find(aggregate => aggregate.hasOwnProperty("metafields"));

          filterValues = filterValues.metafields.find(arrayObject => arrayObject.key == setting.key);

          if(!filterValues) return;

          out.push({
            name: filterName,
            label: filterLabel,
            type: 'metafields',
            values: filterValues.values.map((value) => {
              return {
                label: value.value,
                numProducts: value.numProducts,
                value: `${filterValues.metafieldType}.${filterValues.namespace}.${filterValues.key}.${value.value}`
              }
            })
          })

          return;
        }
      })

      return out;
    }

    // ─── PAGINATION ─────────────────────────────────────────────────────────

    _renderPagination() {
      var container = document.getElementById('rebuy-pagination');
      if (!container) return;

      var totalProducts = this._state.pageInfo.serverSize || 0;
      var pageSize      = this._state.pageInfo.pageSize || this._config.productsPerPage;
      var totalPages    = Math.ceil(totalProducts / pageSize);
      var currentPage   = this._state.currentPage;

      if (totalPages <= 1) { container.innerHTML = ''; return; }

      var prevIcon = '<svg role="presentation" focusable="false" width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 13L2 7l8-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      var nextIcon = '<svg role="presentation" focusable="false" width="11" height="14" viewBox="0 0 11 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1l8 6-8 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      var pageButtons = this._generatePageList(currentPage, totalPages).map(function (p) {
        if (p === null) {
          return '<span class="pagination__link pagination__link--disabled h6">…</span>';
        } else if (p === currentPage) {
          return `<span class="pagination__link pagination__link--disabled h6" aria-current="page">${p}</span>`;
        } else {
          return `<button type="button" class="pagination__link h6" data-rebuy-page="${p}">${p}</button>`;
        }
      }).join('');

      container.innerHTML = `
        <nav class="pagination" role="navigation" aria-label="Pagination">
          ${currentPage > 1 ? `<button type="button" class="pagination__link h6" data-rebuy-page="${currentPage - 1}">${prevIcon}</button>` : ''}
          ${pageButtons}
          ${currentPage < totalPages ? `<button type="button" class="pagination__link h6" data-rebuy-page="${currentPage + 1}">${nextIcon}</button>` : ''}
        </nav>
      `;
    }

    _generatePageList(current, total) {
      if (total <= 7) {
        var list = [];
        for (var i = 1; i <= total; i++) list.push(i);
        return list;
      }
      var pages = [1];
      if (current > 3) pages.push(null);
      for (var j = Math.max(2, current - 1); j <= Math.min(total - 1, current + 1); j++) pages.push(j);
      if (current < total - 2) pages.push(null);
      pages.push(total);
      return pages;
    }

    // ─── TOOLBAR ────────────────────────────────────────────────────────────

    _updateResultCount() {
      var countEl = document.querySelector('.collection-toolbar__products-count');
      if (!countEl || !this._config.productsCountText) return;
      var total = this._state.pageInfo.serverSize || this._state.products.length;
      countEl.textContent = this._config.productsCountText.replace('__COUNT__', total);
    }

    _updateActiveFilterCount() {
      var countEl = document.getElementById('rebuy-active-filters-count');
      if (!countEl) return;
      var count =
        this._state.filters.tags.length +
        this._state.filters.categories.length +
        this._state.filters.vendors.length +
        this._state.filters.options.length +
        this._state.filters.metafields.length +
        (this._state.filters.available === true ? 1 : 0) +
        (this._state.filters.price.min != null || this._state.filters.price.max != null ? 1 : 0);
      countEl.textContent = count > 0 ? ` (${count})` : '';
    }

    // ─── SORT INTERCEPT ─────────────────────────────────────────────────────

    _setupSortIntercept() {
      this._onFacetUpdate = (event) => {
        var url = event.detail && event.detail.url;
        if (!url || !url.searchParams) return;
        var sortBy = url.searchParams.get('sort_by');
        if (!sortBy) return;
        event.stopImmediatePropagation();
        this._state.sortBy = SHOPIFY_SORT_MAP[sortBy] || DEFAULT_SORT;
        this._state.currentPage = 1;
        this._fetchProducts();
        var newUrl = new URL(window.location.href);
        newUrl.searchParams.set('sort_by', sortBy);
        history.replaceState({}, '', newUrl.toString());
      };
      document.addEventListener('facet:update', this._onFacetUpdate, true);
    }

    // ─── ERROR ──────────────────────────────────────────────────────────────

    _renderError() {
      if (!this._productListEl) return;
      this._productListEl.style.opacity = '';
      this._productListEl.style.pointerEvents = '';
      this._productListEl.innerHTML = '<div class="empty-state"><div class="prose"><p>There was an issue loading products. Please try again.</p></div></div>';
    }

    // ─── CUSTOM GRID ITEM ───────────────────────────────────────────────────

    _injectCustomGridItem() {
      var template = document.getElementById('rebuy-custom-grid-item');
      var list = this._productListEl;
      if (!template || !list) return;

      _removeInjectedCustomGridItems(list);

      var position = parseInt(template.getAttribute('data-position'), 10);
      if (isNaN(position) || position < 1) return;

      var productCards = list.querySelectorAll('rebuy-product-card');
      if (position > productCards.length) return;

      var node = _cloneCustomGridNodeFromTemplate(template);
      if (node) productCards[position - 1].before(node);
    }

    // ─── YOTPO ──────────────────────────────────────────────────────────────

    _reinitYotpo() {
      setTimeout(function () {
        if (typeof window.yotpoWidgetsContainer !== 'undefined' &&
            typeof window.yotpoWidgetsContainer.initWidgets === 'function') {
          window.yotpoWidgetsContainer.initWidgets();
        }
      }, 200);
    }

    // ─── FILTER ACTIONS ─────────────────────────────────────────────────────

    _toggleFilter(filterKey, value) {
      switch (filterKey) {
      case 'available':
        this._state.filters[filterKey] = this._state.filters[filterKey] ? null : true;
      break;
      case 'price':
        this._state.filters.price = {};
      break;
      case 'v.price.gte':
          this._state.filters.price.min = value * 100;
        break;
      case 'v.price.lte':
        this._state.filters.price.max = value * 100;
      break;
      default:
        const filterValue = this._state.filters[filterKey];
        const idx = filterValue?.indexOf(value);
        if (idx === -1) filterValue.push(value);
        else filterValue.splice(idx, 1);
      break;
      }

      this._state.currentPage = 1;
      this._fetchProducts();
    }

    _resetFilters() {
      this._state.filters = { tags: [], categories: [], vendors: [], options: [], metafields: [], available: null, price: {} };
      this._state.currentPage = 1;
      this._syncFiltersToUrl();
      this._fetchProducts();
    }

    _goToPage(page) {
      this._state.currentPage = page;
      this._fetchProducts();
      this.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }

  if (!customElements.get('rebuy-collection')) {
    customElements.define('rebuy-collection', RebuyCollection);
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-preview"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('video-preview')) {
    class VideoPreview extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.abortController = new AbortController();
        this.io = new IntersectionObserver(this.observerCallback.bind(this), {
          rootMargin: '300px',
          threshold: ['0', '0.01'],
        });
        this.overlayVideo = this.querySelector('[data-overlay-video]');
        this.fullVideo = this.querySelector('[data-full-video]');
        this.playButton = this.querySelector('.video-preview__play-button');
        this.videoPlaying = false;

        this.playButton.addEventListener('click', this.playVideo.bind(this), {
          signal: this.abortController.signal
        })

        this.fullVideo.addEventListener('pause', this.pauseVideo.bind(this, {playOverlay: true}), {
          signal: this.abortController.signal
        })
        this.io.observe(this);
      }

      observerCallback(entries) {
        entries.forEach((entry) => {
          if(!entry.isIntersecting) {
            if(this.videoPlaying) {
              this.pauseVideo({playOverlay: false});
            } else {
              this.overlayVideo.pause();
            }
          } else {
            if(this.overlayVideo) {
              this.overlayVideo.play();
            }
          }
        });
      }

      pauseVideo({playOverlay}) {
        if(this.fullVideo.ended == true) return;

        this.fullVideo.pause();
        this.classList.remove('is-playing');
        this.videoPlaying = false;

        if (this.overlayVideo && playOverlay == true) {
          this.overlayVideo.play();
          this.playButton.focus();
        }
      }

      playVideo() {
        if (this.overlayVideo) {
          this.overlayVideo.pause();
        }

        this.classList.add('is-playing');
        this.fullVideo.play();
        this.fullVideo.focus();
        this.videoPlaying = true;
      }

      disconnectedCallback() {
        this.abortController.abort();
      }
    }

    customElements.define('video-preview', VideoPreview);
  }

  } catch(e) { console.error(e); }
})();
})();
